<template>
  <div class="page noselect" :class="{withSearchbar: $store.getters.searchIsRenderedNow}">


    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <h1 class="myTitle hidden-md-and-down">Kategorien</h1>-->
    <!--        <div class="spacer-10 hidden-lg-and-up"></div>-->

    <div class="spacer-25"></div>

    <!--        <h2 class="text-center">Speisekarte</h2>-->

    <!--        <SortimentCards :lastGotoDrinks="true"></SortimentCards>-->


    <AllCategories></AllCategories>

    <!--        <SortimentCards></SortimentCards>-->

    <FixBasket></FixBasket>

  </div>
</template>

<script>
// import store from '../store/store'
// import {ebus} from '../vendor/ebus';
// import * as qconst from '../vendor/qconstants';
// import * as util from '../vendor/util'
// import{logPageView} from "../firebase/firebaseUtil";
// import {offerMixin} from "../mixins/offerMixin";
import CategoryCard from "../components/CategoryCard";
import SortimentCards from "../components/SortimentCards";
import FixBasket from "../components/FixBasket";
import AllCategories from "../components/AllCategories";

export default {
  name: "Sortiment",
  components: { AllCategories, FixBasket, SortimentCards, CategoryCard},
  mounted() {
    this.$store.commit('showLoading', false);
  },
  // activated() {
  // logPageView('Sortiment')
  // }
}
</script>

<style scoped lang="scss">

</style>
